export const PAGE_VIEW = 'PAGE_VIEW'
export const HEART_CLICK_DONATE = 'HEART_CLICK_DONATE'
export const HEART_DONATE_COMPLETE = 'HEART_DONATE_COMPLETE'
export const HEART_DONATE_ORGANIZATION = 'HEART_DONATE_ORGANIZATION'
